import React from "react";
import "./MenuComponent.scss";
import Button from "../../Button/Button";

export default function MenuComponent({ t }) {
  return (
    <div className="menu-component">
      <div className="menu-component__content">
        <h1>{t("menu_title")}</h1>
        <p>{t("menu_description")}</p>
        <span>{t("menu_message")}</span>
        <Button to={"/menu"} text={t("menu_button")} variant={"secondary"} />
      </div>
    </div>
  );
}
